"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenCaretIconOffCenter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const OpenCaretIconOffCenter = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "-3 2 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.69666 18.2531L9.22178 19.7782L17 12L9.22178 4.22183L7.69666 5.74695L13.9497 12L7.69666 18.2531Z", fill: "#FBFBFB" }) })));
};
exports.OpenCaretIconOffCenter = OpenCaretIconOffCenter;
//# sourceMappingURL=open_caret_icon_off_center.js.map